import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecarrentalinturbhemidc() {



  const cardData =
  {
    keyword: ' Corporate Car Rental in Turbhe MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Car Rental in Turbhe MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Car Rental in Turbhe MIDC, catering to the transportation needs of industrial units, logistics hubs, warehouses, manufacturing plants, and corporate offices in the area. Our fleet of well-maintained sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, supervisors, clients, and senior executives. Whether it is daily commute, shift-based transportation, inter-facility travel, airport transfers, business meetings, site visits, or VIP movement, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, GPS-enabled vehicles, flexible rental plans, and dedicated service support, Pune Corporate Cars India Private Limited ensures a dependable, efficient, and premium corporate travel experience for businesses operating in and around Turbhe MIDC.',

    top: 'Top Places to Visit in Turbhe with Pune Corporate Car',

 "topPlaces": [
  {
    "title": "Turbhe Garden",
    "description": "Turbhe Garden is one of the peaceful green spaces in Navi Mumbai, ideal for morning walks, jogging, yoga, and family outings. The park features landscaped lawns, benches, and tree-lined paths, providing a calm escape from the bustling residential and industrial areas nearby. Local residents often visit in the mornings and evenings to enjoy fresh air, bird watching, and community interaction, making it a central recreational hub in Turbhe."
  },
  {
    "title": "Turbhe Market",
    "description": "Turbhe Market is a lively shopping destination known for local groceries, fresh produce, clothing, and household items. The market area is bustling with vendors, street food stalls, and small shops catering to daily needs. It reflects the local culture and everyday life of Turbhe residents, offering a vibrant glimpse into the city’s neighborhood commerce and community interactions."
  },
  {
    "title": "Sri Sai Baba Mandir",
    "description": "Sri Sai Baba Mandir in Turbhe is a popular place of worship, attracting devotees from nearby areas. Known for its peaceful ambiance, colorful decorations, and regular spiritual gatherings, the temple offers a serene escape from urban life. Festivals and special prayer days see the temple come alive with devotional music, lamps, and communal celebrations, making it an important cultural and religious hub for the community."
  },
  {
    "title": "Turbhe Lake",
    "description": "Turbhe Lake is a small, scenic water body surrounded by greenery and walking paths. Locals visit for evening strolls, photography, and relaxation beside the water. During monsoon, the lake becomes especially picturesque, attracting nature lovers and families seeking a quiet spot to unwind amidst lush surroundings. The area also provides opportunities for bird watching and enjoying the local flora and fauna."
  },
  {
    "title": "Sector 8 Park",
    "description": "Sector 8 Park is a community recreational area in Turbhe featuring open lawns, children’s play zones, walking paths, and seating areas. Families and residents come here for evening walks, morning exercise routines, and weekend leisure activities. The park also hosts small local events and gatherings, fostering a sense of community among the neighborhood residents."
  },
  {
    "title": "Turbhe Industrial Area Viewpoints",
    "description": "Turbhe is adjacent to Navi Mumbai’s industrial belt, and there are spots along roads and open spaces where visitors can observe the mix of industrial landscapes with distant greenery. While primarily functional for logistics and business, some areas provide scenic viewpoints for photography, especially during sunset, reflecting the blend of urban and natural elements that characterize Turbhe."
  },
  {
    "title": "Local Eateries & Street Food",
    "description": "Turbhe is famous for its affordable and tasty street food, ranging from vada pav, pav bhaji, and pani puri to small local cafés serving South Indian and North Indian dishes. The street food culture brings together locals, office-goers, and students in the evenings, creating a lively and flavorful culinary scene. These food corners are an essential part of the area’s daily life and social interaction."
  },
  {
    "title": "Turbhe Jogging & Cycling Tracks",
    "description": "Certain stretches in Turbhe, especially around parks and residential sectors, have developed jogging and cycling paths. These tracks are popular among morning walkers, runners, and cycling enthusiasts looking for safe, open spaces to exercise. The combination of greenery, fresh air, and community engagement makes these tracks a preferred fitness spot for local residents."
  },
  {
    "title": "Siddhivinayak Temple, Turbhe",
    "description": "This local temple dedicated to Lord Ganesha is a spiritual focal point for Turbhe residents. Known for its colorful festivals, devotional activities, and peaceful surroundings, the temple provides both religious and cultural value to the community. Festivals like Ganesh Chaturthi are celebrated with grandeur, attracting large crowds and fostering neighborhood bonding."
  },
  {
    "title": "Nearby Ghansoli Wetlands",
    "description": "The wetlands near Turbhe and Ghansoli provide a natural retreat with rich biodiversity, migratory birds, and tranquil water bodies. Bird watchers, nature photographers, and locals seeking calm often visit these areas to enjoy the quiet environment. The wetlands also act as a natural buffer, maintaining ecological balance and offering scenic views away from the urban hustle of Turbhe."
  }
],


"services": [
{
"name": "Turbhe MIDC Car Rental",
"description": "Turbhe MIDC Car Rental provides reliable and structured car rental solutions for corporate clients and industrial employees in Turbhe MIDC. The service includes trained drivers, GPS-enabled vehicles, well-maintained sedans and SUVs, and optimized routes to ensure safe, punctual, and comfortable commuting for daily work shifts and office travel."
},
{
"name": "Corporate Car Hire Turbhe",
"description": "Corporate Car Hire Turbhe offers dedicated corporate car services for office employees, executives, and business travelers. The service features professional chauffeurs, GPS-monitored vehicles, structured daily schedules, and well-maintained cars to provide safe, reliable, and efficient transportation."
},
{
"name": "Turbhe Employee Transport",
"description": "Turbhe Employee Transport delivers organized employee commuting solutions for offices, IT parks, and industrial units. The service includes multi-passenger vehicles, trained drivers, GPS tracking, optimized routes, and multi-shift support to ensure efficient, safe, and timely transport."
},
{
"name": "Business Car Lease Turbhe MIDC",
"description": "Business Car Lease Turbhe MIDC provides long-term corporate vehicle leasing solutions for companies operating in Turbhe MIDC. The service includes a managed fleet of sedans and SUVs, driver management, GPS-enabled monitoring, and structured routes to ensure seamless employee commuting."
},
{
"name": "Executive Car Turbhe",
"description": "Executive Car Turbhe delivers premium car services for corporate executives, VIPs, and office staff. The service features luxury sedans, professional chauffeurs, GPS tracking, timely pickups, and well-maintained vehicles for safe, comfortable, and efficient travel."
},
{
"name": "Monthly Car Rental Turbhe",
"description": "Monthly Car Rental Turbhe provides long-term car rental packages for companies requiring consistent employee transportation. The service offers fixed monthly plans, professional drivers, GPS-enabled vehicles, structured schedules, and reliable pickups for stress-free daily commuting."
},
{
"name": "Affordable Corporate Cars Turbhe",
"description": "Affordable Corporate Cars Turbhe offers cost-effective corporate and employee transportation solutions. The service includes reliable pickups, trained chauffeurs, well-maintained sedans and SUVs, GPS-enabled monitoring, and structured routes for safe, timely, and budget-friendly commuting."
},
{
"name": "Sedan Car Hire Turbhe",
"description": "Sedan Car Hire Turbhe provides premium sedans for corporate travel, employee commuting, and executive transport. The service ensures professional chauffeurs, GPS tracking, timely pickups, and well-maintained vehicles to guarantee safe, comfortable, and professional commuting."
},
{
"name": "SUV Car Rental Turbhe",
"description": "SUV Car Rental Turbhe offers spacious and comfortable SUVs suitable for team travel, industrial staff transport, and corporate commuting. The service includes trained drivers, GPS-enabled vehicles, structured routes, and multi-shift support for reliable and safe transportation."
},
{
"name": "Company Fleet Turbhe MIDC",
"description": "Company Fleet Turbhe MIDC provides fully managed corporate fleet solutions including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS monitoring, and structured routes to ensure seamless, safe, and efficient employee commuting."
},
{
"name": "Outstation Car Turbhe",
"description": "Outstation Car Turbhe delivers long-distance corporate and business travel solutions. The service features trained chauffeurs, GPS-enabled vehicles, optimized routes, and comfortable seating to ensure safe, punctual, and hassle-free intercity transportation."
},
{
"name": "Chauffeur Car Turbhe",
"description": "Chauffeur Car Turbhe offers premium chauffeur-driven car services for corporate executives, VIPs, and office staff. The service includes professional drivers, well-maintained vehicles, GPS tracking, and punctual pickups for safe and comfortable commuting."
},
{
"name": "Best Corporate Car Rental Turbhe",
"description": "Best Corporate Car Rental Turbhe provides top-quality corporate car rental services for office employees, executives, and industrial staff. The service ensures professional drivers, GPS-enabled vehicles, structured routes, and punctual pickups for reliable and comfortable commuting."
},
{
"name": "Employee Mobility Turbhe",
"description": "Employee Mobility Turbhe offers comprehensive mobility solutions for companies operating in Turbhe MIDC. The service features multi-passenger shuttles, sedans, SUVs, GPS monitoring, trained drivers, and optimized routes to ensure safe, efficient, and timely employee transportation."
},
{
"name": "Corporate Vehicle Provider Turbhe MIDC",
"description": "Corporate Vehicle Provider Turbhe MIDC delivers fully managed corporate vehicle solutions, including sedans, SUVs, and staff cabs. The service covers driver management, vehicle maintenance, GPS tracking, structured routes, and multi-shift support for seamless and reliable employee commuting."
}
],

"tableData": [
["Turbhe MIDC Car Rental", "Corporate Car Hire Turbhe"],
["Turbhe Employee Transport", "Business Car Lease Turbhe MIDC"],
["Executive Car Turbhe", "Monthly Car Rental Turbhe"],
["Affordable Corporate Cars Turbhe", "Sedan Car Hire Turbhe"],
["SUV Car Rental Turbhe", "Company Fleet Turbhe MIDC"],
["Outstation Car Turbhe", "Chauffeur Car Turbhe"],
["Best Corporate Car Rental Turbhe", "Employee Mobility Turbhe"],
["Corporate Vehicle Provider Turbhe MIDC", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Car Rental in Turbhe MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate car rental services in Turbhe MIDC, ensuring smooth and efficient transportation for business employees and executives."
  },
  {
    "WhyChooseheading": "Punctual Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs, helping employees reach offices, industrial zones, and business hubs in Turbhe MIDC without any delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for safe and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible corporate car rental plans tailored to meet the commuting needs of businesses and employees in Turbhe MIDC."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]
























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Airoli, Mumbai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Airoli, Mumbai.',
  },
  {
    question: 'What types of corporate cab services are available in Airoli?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for businesses.',
  },
  {
    question: 'Do you support daily commuting for employees in Airoli?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift schedules for corporate offices in Airoli.',
  },
  {
    question: 'How can companies book corporate cab services in Airoli?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers depending on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Airoli?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Airoli?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Airoli?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    feedback: 'Highly reliable corporate cab service in Airoli. Punctual, safe, and professional for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Mehta',
    feedback: 'Excellent service for corporate transportation in Airoli. Smooth and hassle-free daily commute for our team.',
    rating: 5,
  },
];






























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Car Rental in Turbhe MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-car-turbhe-midc.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate car rental services in Turbhe MIDC, including employee transport, executive car rentals, corporate car hire, monthly rental plans, business car leasing, outstation trips, chauffeur-driven cars, and fleet solutions for companies operating in Turbhe MIDC.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-car-rental-turbhe-midc"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Corporate Car Rental in Turbhe MIDC | Executive & Corporate Cars</title>

  <meta
    name="description"
    content="Reliable corporate car rental services in Turbhe MIDC including employee transport, executive and business car hire, monthly rental plans, outstation trips, chauffeur-driven cars, and company fleet solutions for businesses in Turbhe."
  />

  <meta
    name="keywords"
    content="Turbhe MIDC Car Rental, Corporate Car Hire Turbhe, Turbhe Employee Transport, Business Car Lease Turbhe MIDC, Executive Car Turbhe, Monthly Car Rental Turbhe, Affordable Corporate Cars Turbhe, Sedan Car Hire Turbhe, SUV Car Rental Turbhe, Company Fleet Turbhe MIDC, Outstation Car Turbhe, Chauffeur Car Turbhe, Best Corporate Car Rental Turbhe, Employee Mobility Turbhe, Corporate Vehicle Provider Turbhe MIDC"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecarrentalinturbhemidc;